import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { FaArrowLeft, FaArrowRight, FaSave } from 'react-icons/fa'
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import storePersist from '../../redux/storePersist'
import { useNavigate } from 'react-router-dom'
import { MultiSelect } from 'react-multi-select-component'
import { YesNoRendererComponent } from './yes-no-renderer.component';
import { currency, format } from '../services/common.service';
import { ExpandTableContainer } from '../expand-table/containers/expand-table.container';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { selectCurrent } from '../../redux/settings/selectors';
import { settings } from '../../redux/settings/actions';
import { UploadDeleteModal } from '../../models/DeleteModal';
import { InputContainer } from './form/input/containers/input.container';
import { FiRefreshCw } from "react-icons/fi";
import PaginationContainer from './form/pagination/container/pagination.container';
import { ValueComponent } from './value.component';
import { ResetModal } from '../../models/reset-modal';
import { useConfirm } from '../../hooks/useConfirm';
import { FilterDrawerComponent } from './filter-drawer';
import { Menu } from '@headlessui/react';
import { LibraryRendererComponent } from './library-renderer.component.1.1';

const Table = ({ onSelect = () => { }, onSelectAll = () => { }, setPageSize, handleEnableTenantWebsite, handlereset, handleUpdateTenantWebsite, handleInputChange, handleSave, IsRowUpdated, subColumnDefs, onOrderStatusClick, launchId, onGeneratePin,
	launchLabel, portalLaunchId, handleLaunchedToPortal, portalLaunchLabel, serviceLaunchId, handleLaunchedToService, serviceLaunchLabel,
	baseUrl, onPaymentStatusClick, onFullfillmentStatusClick, onReturnRequestStatusClick,
	columnData, rowData, onEdit, additionButtons, onDelete, headingName, paginationData, setPageData, onShippingStatusClick,onSearch = () => {},	enableFilter = false,
	filterTypeLists,IsActionButton,handlePushTemplate,handlePullTemplate,onApprovalStatusClick }: any) => {
	const navigate = useNavigate()
	const [anchorShipmentEl, setAnchorShipmentEl] = useState(null);
	const [selectedField, setSelectedField] = useState([]);
	const [showFilter, setShowFilter] = useState(false);
	const [filteredData, setFilteredData] = useState<any>(rowData);
	const [filterType, setFilterType] = useState([])
	const [selectedDateField, setSelectedDateField] = useState('')
	const [filterOption, setFilterOption] = useState(false)
	console.log('baseUrl', baseUrl)
	const [isExpand, setIsExpand] = useState(false);
	const [subRowData, setSubRowdata] = useState<any>();
	const [subRowDataId, setSubRowdataId] = useState<any>();
	const companyName = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.CompanyName;
	const [deleteData, setDeleteData] = useState({})
	const handleSubRowData = (data: any) => {
		setIsExpand(!isExpand)
		if (data?.AssociatedDomains) {
			setSubRowdataId(data?.Id)
			setSubRowdata(data?.AssociatedDomains)
		}

	}
	const [selectedRows, setSelectedRows] = useState<any[]>([]);
	const filteredFields = _.filter(
		columnData,
		(item) => item.field !== 'Sl' && item.field !== 'Edit'
	)
	const [isCheckAll, setIsCheckAll] = useState(false)
	const filterOptions = []
	filterOptions.push({ label: 'Customer Name', value: 'Customer Name' })
	filterOptions.push({ label: 'Email', value: 'Email' })
	filterOptions.push({ label: 'Mobile', value: 'Mobile' })
	filterOptions.push({ label: 'Address', value: 'Address' })
	filterOptions.push({ label: 'City', value: 'City' })
	filterOptions.push({ label: 'State', value: 'State' })
	filterOptions.push({ label: 'Country', value: 'Country' })

	useEffect(() => {
		console.log(selectedField)
		const newdata: any = [...filterType, "string"]
		setFilterType(newdata)

	}, [selectedField])


	const handleEdit = (item: any) => {
		onEdit(item)
	}

	const handleDelete = (item: any) => {
		onDelete(item)
	}

	const handleCheckbox = (data: any, isChecked: boolean) => {
		handleRowSelection(data, isChecked);
		onSelect(data, isChecked);
	};

	const handleSelectAll = (e: any) => {
		setIsCheckAll(!isCheckAll);
		onSelectAll(rowData, e.target.checked)
	}

	const handleLaunchedToSCP = async () => {
		window.open(`${baseUrl}/scp/auth/login/pin`);
		// window.open('http://localhost:3000/scp/pin');
		// navigate('/login/scp/pin')
	}
	const handleFilterType = (e: any, idx: any) => {
		let arr: any = []
		filterType.map((obj: any, index: any) => {
			if (idx == index) {
				arr.push(e.target.value)
			}
			else {
				arr.push(obj)
			}
		})
		setFilterType(arr)
	}

	const { confirm, modal } = useConfirm();

	const handleClickDelete = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to delete ?');
		if (isConfirmed) {
			handleDelete(data)			
		}
	};
	const handleClickReset = async (data: any) => {
		const isConfirmed = await confirm('Are you sure you want to Reset?');
		if (isConfirmed) {
			handlereset(data)			
		}
	};

	const { PageNumber, PageSize } = paginationData || { PageNumber: 1, PageSize: 10 };
	const startIndex = (PageNumber - 1) * PageSize + 1;
	const handleRowSelection = (row: any, isChecked: boolean) => {
		setSelectedRows(prevSelectedRows => {
			if (isChecked) {
				return [...prevSelectedRows, row];
			} else {
				return prevSelectedRows.filter(selectedRow => selectedRow !== row);
			}
		});
	};
	return (

		<>
			<div className="p-4">
				<div className="flex my-2  w-full justify-between items-center px-2">
					<div className="uppercase text-xl">
						{headingName ? headingName : ''}
					</div>
					{enableFilter && <FilterDrawerComponent 
						columnData={columnData} 
						rowData={rowData} 
						filterTypeLists={filterTypeLists} 
						setFilteredData={setFilteredData} 
						initiateSearch={onSearch}
						showFilter={showFilter} 
						setShowFilter={setShowFilter}
					/>}
					<div className="flex flex-row">
						




						{additionButtons?.length && additionButtons.map((button: any) => (
							<button
								onClick={(event) => button.callback(event)}
								type="button"
								className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
							>
									  <span className=''>{button.svg}</span>
									  <span className=''>{button.name}</span>
							</button>
						))}
						{enableFilter && <button
								onClick={() => setShowFilter(!showFilter)}
								type="button"
								className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "								
							>
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
								<path d="M8.85746 12.5061C6.36901 10.6456 4.59564 8.59915 3.62734 7.44867C3.3276 7.09253 3.22938 6.8319 3.17033 6.3728C2.96811 4.8008 2.86701 4.0148 3.32795 3.5074C3.7889 3 4.60404 3 6.23433 3H17.7657C19.396 3 20.2111 3 20.672 3.5074C21.133 4.0148 21.0319 4.8008 20.8297 6.37281C20.7706 6.83191 20.6724 7.09254 20.3726 7.44867C19.403 8.60062 17.6261 10.6507 15.1326 12.5135C14.907 12.6821 14.7583 12.9567 14.7307 13.2614C14.4837 15.992 14.2559 17.4876 14.1141 18.2442C13.8853 19.4657 12.1532 20.2006 11.226 20.8563C10.6741 21.2466 10.0043 20.782 9.93278 20.1778C9.79643 19.0261 9.53961 16.6864 9.25927 13.2614C9.23409 12.9539 9.08486 12.6761 8.85746 12.5061Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</button>}

					</div>


				</div>


				<div className="h-[500px] overflow-auto">
					{rowData?.length !== 0 ? <table className="w-full text-xs bg-red-50">
						<thead className="w-full border-y border-black border-opacity-20 ">
							<tr key={'table'} className="w-full text-left h-12">
								<th key={0}
									className="px-5">
									<input
										checked={isCheckAll}
										type="checkbox"
										name="selectAll"
										id="selectAll"
										onChange={(e: any) => handleSelectAll(e)} />

								</th>
								<th key={1}>
									#
								</th>
								{columnData[0]?.isSortLabel ?
									filteredFields.map((column: any, index: any) => (
										<th key={index}
											className=" text-center border-r-2 text-skin-ouprimary first:border-r-0 last:border-r-0 w-auto px-10 truncate">{column.headerName}</th>

									))
									:
									filteredFields.map((column: any, index: any) => (
										<th key={index}
											className=" text-center border-r-2 text-skin-ouprimary first:border-r-0 last:border-r-0 w-auto px-10 truncate">
											{column.headerName}
										</th>

									))}
								<th
									className=" border-r-2  last:border-r-0 w-auto px-10">
									Action
								</th>
							</tr>
						</thead>
						<tbody className="bg-red-400 text-sm font-light max-h-24 overflow-y-auto">
							<>
								{rowData && rowData?.map((row: any, index: any) => (
									<><tr key={row}
										className="w-full cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
										<td key={0}>
											<span className="px-5">
												<input
													type="checkbox"
													checked={selectedRows.includes(row)}
													onChange={(e) => handleCheckbox(row, e.target.checked)}
												/>
											</span>
										</td>
										<td key={1}>
											{startIndex + index}
										</td>
										{filteredFields.map((column) => {
											const dataValue: any = _.property(column.field)(row)
											const address = `${dataValue?.address?.building} , ${dataValue?.address?.locality} , ${dataValue?.address?.city} , ${dataValue?.address?.country} , ${dataValue?.address?.state} - ${dataValue?.address?.area_code}`;
											return (
												<>
											
													<td key={index} className="px-10  w-auto">
														{modal}
														{column.cellRenderer !== 'imageRenderer' && !column.input && column.cellRenderer !== 'resetIconRenderer' && column.isCurrencyValueFormat !== true && column.isAddressFormat !== true && column.isDateValueFormat !== true &&
															!column.valueFormatter && column.cellRenderer !== 'yesNoRenderer' && column.cellRenderer !== 'libraryRendererComponent' &&
															<div
																className="truncate"
																title={dataValue?.length > 25 ? dataValue : ''}
															>
																{dataValue?.length > 25 ? `${dataValue.substring(0, 25)}...` : dataValue}
															</div>
														}
														{column.isDateValueFormat === true && (
															<p className="truncate">
																{format(dataValue)}
															</p>
														)}
														{column.isCurrencyValueFormat === true && (
															<p >
																{currency(dataValue)}
															</p>
														)}

														{column.valueFormatter && (
															<ValueComponent value={dataValue} valueFormatter={column.valueFormatter} />
														)}
														{column.input && (
															<InputContainer
																type={column.type}
																value={dataValue}
																onValueChange={(event: any) => handleInputChange(event, column.field, row)}
																showToolTip
																className="w-full"
															/>
														)}
														{column.cellRenderer === 'imageRenderer' && (
															<img src={dataValue} className="w-16 h-16 object-contain" />
														)}
														{column.isUpdateTenantWebsite &&
															<button
															title= 'Add New Updated cards published in Platform Website'
																type="button"
																className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
																onClick={() => handleUpdateTenantWebsite(row)}
															>
																Update
															</button>}
															{column.cellRenderer === 'resetIconRenderer' && (
															  <button
															  className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2"
															  onClick={() => handleClickReset(row)}
															  title= 'Reset the current website and create new records  with Platform Website'
															>
															  <FiRefreshCw />
															</button>
														)}
														{column.isEnableTenantWebsite &&
															<button
																type="button"
																className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-2 "
																onClick={() => handleEnableTenantWebsite(row)}
																title= 'To active the website'
															>
																Enable
															</button>}
														{column.isAddressFormat === true &&
															<p className='font-semibold truncate'
																title={address?.length > 25 ? address : ''}
															>
																{address?.length > 25 ? `${address.substring(0, 25)}...` : address}
															</p>
														}
														{column.cellRenderer === 'yesNoRenderer' && (
															<YesNoRendererComponent
																cellRenderer={column.cellRenderer}
																value={dataValue} />
														)}
														
														{column.cellRenderer === 'libraryRendererComponent' &&
															<div className='flex justify-center items-center'>
																<LibraryRendererComponent
																	cellRenderer={column.cellRenderer}
																	cellRendererParams={column.cellRendererParams}
																	data={column}
																	dataId={row}
																	// onOrderStatusClick={onOrderStatusClick}
																	// onApprovalStatusClick={onApprovalStatusClick}
																	// onPaymentStatusClick={onPaymentStatusClick}
																	// onFullfillmentStatusSubmit={onFullfillmentStatusClick}
																	// onReturnRequestStatusClick={onReturnRequestStatusClick}
																	// onShippingStatusClick={onShippingStatusClick}
																	value={dataValue}
																/>
															</div>
														}

														{column.isExpanded &&

															<button
																aria-label="expand row"
																className="p-2 text-2xl"

																onClick={() => handleSubRowData(row)}
															>
																{isExpand ? <HiChevronUp /> : <HiChevronDown />}
															</button>}
														{column.isLaunched === true &&
															<>
																<p onClick={async () => onGeneratePin(row)}>
																	<span className=" text-blue-800 no-underline hover:underline font-semibold w-auto">Generate PIN</span>
																	{/* {launchId === row.Id && `${' - '}${launchLabel}` } */}
																</p>
																<br />
																{console.log('launchId === row.Id', launchId, row.Id, launchId === row.Id)}
																{launchId === row.Id &&
																	<p onClick={async () => handleLaunchedToSCP()}>
																		<span className="w-auto no-underline hover:underline text-lime-700 font-semibold">Launch SCP</span>
																	</p>}<span>{launchId === row.Id && `${' Use PIN: '}${launchLabel}`}</span>
															</>}


														{column.isLaunchedPortal === true && row.IsCSGAccessEnabledForPortal === true &&
															<>
																<p onClick={async () => onGeneratePin(row, 'Portal')}>
																	<span className=" text-blue-800 no-underline hover:underline font-semibold w-auto">Generate PIN</span>
																	{/* {launchId === row.Id && `${' - '}${launchLabel}` } */}
																</p>
																<br />
																{console.log('portalLaunchId === row.Id', portalLaunchId, row.Id, portalLaunchId === row.Id)}
																{portalLaunchId === row.Id &&
																	<p onClick={async () => handleLaunchedToPortal(row)}>
																		<span className="w-auto no-underline hover:underline text-lime-700 font-semibold">Launch Portal</span>
																	</p>}<span className='cursor-copy'>{portalLaunchId === row.Id && `${' Use PIN: '}${portalLaunchLabel}`}</span>
															</>}

														{column.isLaunchedService === true && row.IsCSGAccessEnabledForService === true &&
															<>
																<p onClick={async () => onGeneratePin(row, 'Service')}>
																	<span className=" text-blue-800 no-underline hover:underline font-semibold w-auto">Generate PIN</span>
																	{/* {launchId === row.Id && `${' - '}${launchLabel}` } */}
																</p>
																<br />
																{console.log('serviceLaunchId === row.Id', serviceLaunchId, row.Id, serviceLaunchId === row.Id)}
																{serviceLaunchId === row.Id &&
																	<p onClick={async () => handleLaunchedToService(row)}>
																		<span className="w-auto no-underline hover:underline text-lime-700 font-semibold">Launch Service</span>
																	</p>}<span className='cursor-copy'>{serviceLaunchId === row.Id && `${' Use PIN: '}${serviceLaunchLabel}`}</span>
															</>
														}


													</td>

												</>
											)
										})}

<td key={9} className="flex p-5 w-max flex-row justify-center item-baseline cursor-pointer">
	{modal}
											<div className="flex items-center">
												<div className='flex flex-row justify-center items-center'>
											{onEdit && <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleEdit(row)} width="12" height="12" viewBox="0 0 24 24"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>}
											{onDelete && <div><svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleClickDelete(row)} width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>{modal}</div>}
											{IsRowUpdated &&
												<button className="text-black-500 hover:text-black-700" onClick={async () => handleSave(row)}>
													<FaSave className="w-3 h-3" />
												</button>}
												{IsActionButton &&
													<Menu as="div" className="relative text-left">
														<div>
															<Menu.Button
																onClick={(e : any) => setAnchorShipmentEl(e.currentTarget)}
																className="pt-1 pl-1 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	fill="currentColor"
																	viewBox="0 0 24 24"
																	width="18"
																	height="18"
																>
																	<circle cx="12" cy="5" r="2" />
																	<circle cx="12" cy="12" r="2" />
																	<circle cx="12" cy="19" r="2" />
																</svg>
															</Menu.Button>
														</div>

														{anchorShipmentEl && (
															<Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }} >
																<div className="px-1 py-1">
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handlePushTemplate(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-100' : ''
																					} group flex rounded-md items-center w-full px-2 py-2 text-sm text-black									}`}
																				title="Push the template you want  from QA to PROD"
																			>
																				Push the website
																			</button>
																		)}
																	</Menu.Item>
																</div>
															</Menu.Items>)}
													</Menu>
												}
												</div>
												</div>
										</td>
									</tr>
										<ExpandTableContainer
											subRowData={subRowData}
											isExpand={isExpand}
											subRowDataId={subRowDataId}
											subColumnDefs={subColumnDefs}
											row={row}
											columnData={columnData} /></>
								)
								)
								}
							</>
						</tbody>
					</table>
						:
						<div className='w-full text-start text-xl p-6 border-2 border-skin-ouprimary rounded-lg'>No Data in the page</div>}
				</div>

				{rowData?.length !== 0 ? <div className="flex items-center justify-center w-full gap-8 my-2">
					<PaginationContainer
						pages={paginationData}
						handleChangeRowsPerPage={setPageSize}
						handleFirstPageButtonClick={() => setPageData(1)}
						handleBackButtonClick={() => setPageData(paginationData?.PageNumber - 1)}
						handleNextButtonClick={() => setPageData(paginationData?.PageNumber + 1)}
						handleLastPageButtonClick={() => setPageData(paginationData?.TotalPages || 1)}
					/>	</div> : ''}
			</div>
			{/* {additionButtons?.length && <div className=' flex w-full justify-end items-end '>
			  {additionButtons.map((button: any) => (
				  <button
					  onClick={(event) => button.callback(event)}
					  type="button"
					  className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
				  >
					  {button.name}
				  </button>
			  ))}



		  </div>} 
	  <div className="min-h-[450px] w-full flex justify-center overflow-auto bg-white bg-opacity-25 shadow-xl p-4 rounded">

			  {rowData?.length !== 0 ? <table className="w-screen text-xs justify-center">

				  <thead className="w-full border-y border-black border-opacity-10 ">
					  <tr key={'table'} className="w-full text-left h-12">
						  <th key={0}
							  className="px-5 border-r-2  last:border-r-0 w-auto">
							  <input
								  checked={isCheckAll}
								  type="checkbox"
								  name="selectAll"
								  id="selectAll"
								  onChange={(e: any) => handleSelectAll(e)} />
						  </th>
						  {columnData[0]?.isSortLabel ?
							  filteredFields.map((column: any, index: any) => (
								  <th key={index}
									  className=" text-center border-r-2 text-skin-ouprimary first:border-r-0 last:border-r-0 w-auto px-10">{column.headerName}</th>

							  ))
							  :
							  filteredFields.map((column: any, index: any) => (
								  <th key={index}
									  className=" text-center border-r-2 text-skin-ouprimary first:border-r-0 last:border-r-0 w-auto px-10">
									  {column.headerName}
								  </th>

							  ))}
						  <th
							  className=" border-r-2  last:border-r-0 w-auto px-10">
							  Action
						  </th>
					  </tr>
				  </thead>
				  <tbody className="w-full ">
					  {rowData.map((row: any, index: any) => (
						  <tr key={row}
							  className="w-full  cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white  odd:bg-opacity-25">
							  <td key={0}>
								  <span className="px-5   w-auto justify-center">
									  <input
										  type="checkbox"
										  defaultChecked={false}
										  onChange={(e) => handleCheckbox(e)}
										  checked={false} />
								  </span>
							  </td>
							  {filteredFields.map((column) => {
								  const dataValue: any = _.property(column.field)(row)
								  return (

									  <>
										  <td key={index} className="px-10  w-auto">
											  {dataValue}
										  </td>

									  </>
								  )
							  })}
							  <td key={9} className="flex px-5 w-max flex-row  justify-start item-baseline cursor-pointer pt-6 space-x-2">
								  <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleEdit(row)} width="12" height="12" viewBox="0 0 24 24"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>
								  <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleDelete(row)} width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>
							  </td>
						  </tr>
					  ))}
				  </tbody>
			  </table>
				  :
				  <div className='w-full text-start text-xl p-6 border-2 border-skin-ouprimary rounded-lg'>No Data in the page</div>}
		  </div> */}
		</>


	)
}

export default Table